export default "__VITE_ASSET__CdVZFt5k__"